import * as React from 'react';

export interface ReactButtonData {
    id?: string,
    name?: string,
    text?: string,
    title?: string,
    css?: string,
    onClick?: (rowObj: any, rowIndex: number) => void,
    row: any,
    rowIndex?: number,
    style?: {},
    disabled?: boolean,
    disableID?: string,
    tabIndex?: null,
    stopPropagationOnClick?: boolean,
    onKeyDown?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => null,
    onKeyUp?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => null,
    stopPropagationOnKeyPress?: (rowOBJ: any, rowIndex: number, keyPressed: string, bOnKeyUp: boolean, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,
}

export interface ReactButtonState {
    disabled: boolean,
    row: any,
}

export class ReactButton extends React.Component<ReactButtonData> {
    constructor(props: ReactButtonData) {
        super(props);
        this.state = {disabled: (props.disabled), row: props.row};

        // Binding is necessary to allow these functions access to the State data
        this.handleClick = this.handleClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactButtonData) {
        this.setState({
            disabled: props.disabled,
            row: props.row,
        });
    }

    onKeyPress(event: any) {
        if(null != this.props.onKeyDown) {
            this.props.onKeyDown((this.state as ReactButtonState).row, this.props.rowIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }

        if(null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = this.props.rowIndex;
            const selectRow = (this.state as ReactButtonState).row;
            if(this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, false, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onKeyUp(event: React.KeyboardEvent<HTMLInputElement>) {
        if (null != this.props.onKeyUp) {
            this.props.onKeyUp((this.state as ReactButtonState).row, this.props.rowIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }
        if(null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = this.props.rowIndex;
            const selectRow = (this.state as ReactButtonState).row;
            if(this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, true, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    handleClick(event: React.MouseEvent<HTMLButtonElement>) {
        if(null != this.props.onClick) {
            this.props.onClick((this.state as ReactButtonState).row, this.props.rowIndex);
        }

        if(null != this.props.stopPropagationOnClick && this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    getButton() {
        if(this.props.title) {
            return <button type="button" disabled={(this.state as ReactButtonState).disabled} className={this.props.css} id={this.props.id} name={this.props.name} style={this.props.style} onClick={this.handleClick} onKeyDown={this.onKeyPress} onKeyUp={this.onKeyUp} title={this.props.title} tabIndex={this.props.tabIndex}>{this.props.text}</button>;
        } else {
            return <button type="button" disabled={(this.state as ReactButtonState).disabled} className={this.props.css} id={this.props.id} name={this.props.name} style={this.props.style} onClick={this.handleClick} onKeyDown={this.onKeyPress} onKeyUp={this.onKeyUp} tabIndex={this.props.tabIndex}>{this.props.text}</button>;
        }
    }

    render() {
        return <React.Fragment>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactButtonState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {this.getButton()}
        </React.Fragment>
    }
}
